import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { UserTableService } from '../core/database/user-table.service';
import { PermissionService } from '../core/database/permission.service';

@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.scss'],
})
export class LogOutComponent implements OnInit {
  constructor(
    public authService: AuthService,
    private readonly userTableService: UserTableService,
    private readonly permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.userTableService.clear();
    this.permissionService.clear();
    this.authService.setUiAuthenticated(false);
    this.authService.logout();
  }
}
